import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ForgotPasswordModalPage } from './forgot-password-modal';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ForgotPasswordModalPage,
  ],
  imports: [
    TranslateModule,
    IonicPageModule.forChild(ForgotPasswordModalPage),
  ],
})
export class ForgotPasswordModalPageModule {}



// WEBPACK FOOTER //
// ./src/app/shared/forgot-password-modal/forgot-password-modal.module.ts